import React from "react";

const ImageSpecificationsCard = () => {
    return (
        <>
            <div className="card image-specification-container">
                <div>
                    <b>Image Specs</b>
                </div>
                <br />
                <div>
                    <b>Image size:</b> 1200 x 628 px x or larger
                </div>
                <div>
                    <b>File size:</b> 5MB or smaller
                </div>
                <div>
                    <b>File format:</b> PNG or JPG
                </div>
                <div>
                    <b>Content:</b> No text, graphics, or logos added to the
                    image
                </div>
                <br />

                <div>
                    <b>Video Specs</b>
                </div>
                <br />
                <div>
                    <b>Aspect ratio:</b> 16:9
                </div>
                <div>
                    <b>Dimensions:</b>1280 x 720px, 1920 x 1080px or 3840 x
                    2160px
                </div>
                <div>
                    <b>File size:</b>500 MB or smaller
                </div>
                <div>
                    <b>File format:</b> PNG or JPG
                </div>
                <div>
                    <b>Length:</b>6-45 sec
                </div>
                <div>
                    <b>Frame rate:</b>23.976, 24, 25, 29.97, 29.98, or 30 fps
                </div>
                <div>
                    <b>Bit rate:</b> 1 Mbps or higher
                </div>
                <div>
                    <b>Codec:</b> H.264 or H.265
                </div>
                <div>
                    <b>Profile:</b> Main or baseline
                </div>
                <div>
                    <b>Codec:</b> H.264 or H.265
                </div>
                <div>
                    <b>Codec:</b> H.264 or H.265
                </div>
                <br />

                <div>
                    <b>Audio Specs</b>
                </div>
                <br />
                <div>
                    <b>Language:</b>Must match ad locale
                </div>
                <div>
                    <b>Sample rate:</b>44.1 kHz or higher
                </div>
                <div>
                    <b>Codec:</b>PCM, AAC or MP3
                </div>
                <div>
                    <b>Bit rate:</b>96 kbps or higher
                </div>
                <div>
                    <b>Format:</b> Stereo or mono
                </div>
                <div>
                    <b>Audio stream:</b> 1 only
                </div>
            </div>
        </>
    );
};

export default ImageSpecificationsCard;
